import makeService from './api';

export default makeService('operating_systems');
